import { DOCUMENT } from '@angular/common'
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Observable } from 'rxjs'

/**
   * Intercept the HTTP request and add the default headers for `Accept-Language`
   *
   * @param req   Current HTTP Request that is being made
   * @param next  HTTP Handler that will take over when the request is complete
   *
   * @returns     Returns an observable of the event stream
   */
export function acceptLanguageHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  let document = inject(DOCUMENT)

  let updatedheaders = req.headers.set('Accept-Language', document.documentElement.lang)

  let updatedRequest = req.clone({
    headers: updatedheaders
  })

  return next(updatedRequest)
}
